import React, { useEffect } from 'react';

import { translations } from '../../locale/translations';
import { SignUpProps } from '../Credentials';
import { Button, FormControl, Link, Radio, SwitchPage, Title } from '../shared.styles';
import { BusinessMessage } from './SignUp.styles';

export const SignUp = ({ formState, setFormState, signupType, mixPanelTracker, switchPage, lang }: SignUpProps) => {
    const locale = translations[lang];

    useEffect(() => {
        mixPanelTracker.track('SignUp', 'UserTypeOpen', { signupType: signupType });
    }, []);

    const handleChange = (value: string) => {
        setFormState({ isBusiness: value === 'true' });
    };

    const handleNext = async () => {
        const userType = formState.isBusiness ? 'business' : 'private';

        await mixPanelTracker.track('SignUp', 'UserType', {
            userType: userType,
            signupType: signupType
        });

        switchPage('CreateAccount');
    };

    return (
        <>
            <Title>
                {locale.signUpHeader1_1}
                <br />
                {locale.signUpHeader1_2}
            </Title>

            <FormControl data-testid="option-business">
                <Radio
                    checked={formState.isBusiness}
                    label={locale.business}
                    labelPosition="right"
                    onChange={() => handleChange('true')}
                />
            </FormControl>
            <FormControl data-testid="option-private">
                <Radio
                    checked={!formState.isBusiness}
                    label={locale.private}
                    labelPosition="right"
                    onChange={() => handleChange('false')}
                />
            </FormControl>

            <BusinessMessage>{locale.signUpBusinessMessage}</BusinessMessage>

            <Button data-testid="go-next" emphasis="accent" size="m" onClick={handleNext}>
                {locale.next}
            </Button>

            <SwitchPage>
                {locale.haveAnAccount}{' '}
                <Link data-testid="login" onClick={() => switchPage('SignIn')}>
                    {locale.login2}
                </Link>
            </SwitchPage>
        </>
    );
};
